// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const CheckoutIcon = ({ isPaused = false }) => null;
